import { useState, useRef } from "react";
import { Col, Form, Input, Row, Modal } from "antd";
import { backendPatchWithoutRefresh } from "../../../helpers/callBackend";
import LoadingButton from '@mui/lab/LoadingButton';

const EditGroup = (props) => {
	const [visible, setVisible] = useState(false);
	const [inFlight, setInFlight] = useState(false);

	const formRef = useRef();

	const onFormSubmit = async (values) => {
		let data = {
			...values,
			id: props.groupId,
		};
		setInFlight(true);
		try {
			const res = await backendPatchWithoutRefresh("/api/generic-tag/group/", data);
			const editedGroup = res?.data?.generic_group;
			props.handleEditSuccess(editedGroup);
			setVisible(false);
		} catch (error) {
			console.error(error);
		}
		setInFlight(false);
	};

	const showModal = () => {
		setVisible(true);
	};

	const handleCancelModal = () => {
		setVisible(false);
	};

	return (
		<>
			<span
				onClick={showModal}
				style={{
					cursor: "pointer",
					color: "#1890ff",
				}}
			>
				Edit
			</span>

			{visible && (
				<Modal visible={visible} onCancel={handleCancelModal} width={600} title="Edit Group" footer={null}>
					<Form layout="vertical" name="basic" onFinish={onFormSubmit} autoComplete="off" ref={formRef}>
						<Row>
							<Col span={24}>
								<Form.Item
									label="Name"
									name="name"
									placeholder="Group Name"
									rules={[
										{
											required: true,
											whitespace: true,
											message: "Please input group name",
										},
									]}
									initialValue={props.groupName}
								>
									<Input />
								</Form.Item>
							</Col>
						</Row>

						<Row>
							<Col span={24}>
								<Form.Item
									label="Description"
									name="description"
									placeholder="Group Description"
									rules={[
										{
											required: true,
											whitespace: true,
											message: "Please input group's notes",
										},
									]}
									initialValue={props.groupDescription}
								>
									<Input />
								</Form.Item>
							</Col>
						</Row>

						<Form.Item>
							<LoadingButton sx={{ fontSize: 14, textTransform: 'none' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary" htmlType="submit" style={{ margin: "3px", width: "100%" }} loadingPosition="start" loading={inFlight}>
								Submit
							</LoadingButton>
						</Form.Item>
					</Form>
				</Modal>
			)}
		</>
	);
};

export default EditGroup;
